import React from 'react';
import {Box} from '@mui/system';
import {gridCellDef} from './GridCellDef';

export const renderCellCurrency: gridCellDef<unknown> = (params) => {
  if (params.value === null) {
    return '-';
  }
  const input = params.value as string;
  return (
    <Box flex={1} textAlign="right" alignContent="right" justifyContent="right">
      {Number(input).toLocaleString('en-GB', {style: 'currency', currency: 'GBP'})}
    </Box>
  );
};
